import { Dashboard } from "../../../shared/components/dashboard/dashboard";
import ErrorBoundary from "../../../shared/components/error-boundary/error-boundary";
export function FrontOfficeDashboard() {
  return (
    <ErrorBoundary>
      <Dashboard userType="front-office" />
    </ErrorBoundary>
  );
}
